import { render, staticRenderFns } from "./LicenseForm2.vue?vue&type=template&id=4282e4b8&"
import script from "./LicenseForm2.vue?vue&type=script&lang=js&"
export * from "./LicenseForm2.vue?vue&type=script&lang=js&"
import style0 from "./LicenseForm2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports